module.exports = __webpack_public_path__ + "static/media/android.e621a6e3.png";